import { useState, useEffect } from 'react';
import { Container, Spinner } from 'react-bootstrap';
import ImageCard from './imageCard';
import './style.css';
import { DownloadImages, GetWatermarkOptions } from '../../services/useProductDetail';
import { Image, ImageType } from '../../models/image';

const WebReadyImages = (props: any) => {
  //let images = props.productImages;
  const [waterMark, setWaterMark] = useState(0);
  const [images, setImages] = useState(props.productImages);
  const [selImageIds, setSelImageIds] = useState<any[]>([]);
  const [selImageNames, setSelImageNames] = useState<any[]>([]);
  const [allChecked, setAllChecked] = useState(false);
  const [isDownLoading, setIsDownLoading] = useState(false);
  const {data: watermarkTypes, isLoading} = GetWatermarkOptions(props.sku);

  const handleOnClick = (e: any, value: number) => {
    const checked = e.target.checked;
    if (checked) {
      setWaterMark((preVal) => preVal | value);
    } else {
      setWaterMark((preVal) => preVal & ~value);
    }
  };

  const handleDownloadClick = (e: any) => {
    setIsDownLoading(true);
    let _selImageIds = [...selImageIds];
    let _fileName = '';
    if (_selImageIds.length == 0) {
      return;
    } else if (_selImageIds.length == 1) {
      _fileName = selImageNames[0] + '.jpg';
    } else if (_selImageIds.length > 1) {
      _fileName = props.sku + '.zip';
    }
    var params = {
      sku: props.sku,
      imageIds: _selImageIds,
      fileName: _fileName,
      waterMark: waterMark,
    };
    DownloadImages(params).then(() => setIsDownLoading(false));
  };

  const handleSelectAllClick = (e: any) => {
    setAllChecked(e.target.checked);
    let _images = images;
    const _imageIds: string[] = [];
    _images.map((image: Image, index: number) => {
      image.IsChecked = e.target.checked;
      if (e.target.checked) {
        _imageIds.push(image.ImageId);
      }
    });
    setImages(_images);
    setSelImageIds(_imageIds);
  };

  const handleSelectImage = (e: any, imageId: string, imageName: string) => {
    let _selImageIds = [...selImageIds];
    let _selImageNames = [...selImageNames];
    let _images = [...images];
    let _allChecked = allChecked;
    if (e.target.checked) {
      _selImageIds.push(imageId);
      _selImageNames.push(imageName);
      _images.map((image: Image, index: number) => {
        if (image.ImageId == imageId) {
          image.IsChecked = true;
        }
        if (!image.IsChecked) {
          _allChecked = false;
        }
      });
    } else {
      var index = _selImageIds.indexOf(imageId);
      _selImageIds.splice(index, 1);
      _selImageNames.splice(index, 1);
      _images.map((image: Image, index: number) => {
        if (image.ImageId == imageId) {
          image.IsChecked = false;
        }
        if (!image.IsChecked) {
          _allChecked = false;
        }
      });
    }

    setAllChecked(_allChecked);
    setSelImageIds(_selImageIds);
    setSelImageNames(_selImageNames);
    setImages(_images);
  };

  return isLoading ? null : (
    <>
      <div className="checkbox-container">
        <div className="chkwatermark">
          {watermarkTypes.map((watermark: any) => {
            return (
              <span className={`${!watermark.enabled ? 'opacity-half' : ''}`} key={watermark.value}>
                <input
                  type="checkbox"
                  value={watermark.value}
                  disabled={!watermark.enabled}
                  onClick={(e) => {
                    handleOnClick(e, watermark.value);
                  }}
                />{' '}
                {watermark.title}
              </span>
            );
          })}
        </div>
      </div>
      <div className="checkbox-container">
        <div className="download">
          <label
            style={{ cursor: 'pointer' }}
            onClick={(e) => {
              if (isDownLoading) return;
              handleDownloadClick(e);
            }}
          >
            {isDownLoading && <Spinner animation="border" size="sm" />} DOWNLOAD IMAGES
          </label>
          Select All
          <input
            id="chkSelectAll"
            name="chkSelectAll"
            type="checkbox"
            value="true"
            checked={allChecked}
            onChange={(e) => {
              handleSelectAllClick(e);
            }}
          />
        </div>
      </div>
      <Container className="image-page-body">
        <Container className="image-page-content-container">
          <div className="image-page-main">
            {images &&
              images.map((image: any, index: number) => {
                return (
                  <ImageCard
                    key={image.ImageId}
                    image={image}
                    sku={props.sku}
                    waterMark={waterMark}
                    handleSelectImage={handleSelectImage}
                  />
                );
              })}
          </div>
        </Container>
      </Container>
    </>
  );
};

export default WebReadyImages;
